import type { AppDispatch } from "../reducer"
import { BonusActions } from "./constants"

export type MiniCartOpenAction = {
  type: BonusActions.MINI_CART_OPEN
}

export type MiniCartCloseAction = {
  type: BonusActions.MINI_CART_CLOSE
}

export type BackToShopUrlSetAction = {
  type: BonusActions.BACK_TO_SHOP_URL_SET
  shopUrl: string
}

export const openCpShopMiniCart = (): MiniCartOpenAction => ({
  type: BonusActions.MINI_CART_OPEN,
})

export const closeCpShopMiniCart = (): MiniCartCloseAction => ({
  type: BonusActions.MINI_CART_CLOSE,
})

export const CP_SHOP_MINI_CART_AUTO_CLOSE_DELAY = 10_000

// Module-level (not component-scoped) so the timer survives the AX drawer
// unmounting right after scheduling it, and a later call can still clear it.
let closeCpShopMiniCartTimeoutId: ReturnType<typeof setTimeout> | undefined

export function scheduleCloseCpShopMiniCart(
  delay: number = CP_SHOP_MINI_CART_AUTO_CLOSE_DELAY
) {
  return (dispatch: AppDispatch) => {
    clearTimeout(closeCpShopMiniCartTimeoutId)

    closeCpShopMiniCartTimeoutId = setTimeout(() => {
      dispatch(closeCpShopMiniCart())
    }, delay)
  }
}

export const setBackToShopUrl = (shopUrl: string): BackToShopUrlSetAction => ({
  type: BonusActions.BACK_TO_SHOP_URL_SET,
  shopUrl,
})
